/**
 * Creates a new DoseReferenceLevelsController.
 * @class
 */
class DoseReferenceLevelsController {
    constructor($log, NavigationService) {
        this.$log = $log;
        this.NavigationService = NavigationService;
    }

    $onInit() {
        this.$log.debug('DoseReferenceLevels::init');
        const navConfig = this.NavigationService.getNavConfig();
        this.colorName = navConfig.colorName;
        this.icon = navConfig.icon;
    }
}

DoseReferenceLevelsController.$inject = ['$log', 'NavigationService'];

export const doseReferenceLevels = {
    controller: DoseReferenceLevelsController,
    template: `
        <div class="loader formHeader">
            <asset cls="color{{$ctrl.colorName}}" src="{{$ctrl.icon}}"></asset>
            <div class="color{{$ctrl.colorName}}">Coming soon...</div>
        </div>
    `
};
